export enum MediaProperties {
  Processed = 'processed',
  Description = 'description',
  Name = 'name',
  MediaType = 'mediaType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
  MediaRel = 'mediaRel',
  IsPrivate = 'isPrivate',
  Restrictions = 'restrictions',
  Likes = 'likes',
  MediaStatus = 'mediaStatus',
  MediaInformation = 'mediaInformation',
  MediaReactions = 'mediaReactions',
  Tag = 'tag',
  Thumbnails = 'thumbnails',
  Published = 'published',
  Released = 'released',
  TransparentTitleUrl = 'transparentTitleUrl',
  Rating = 'rating',
  TransparentTitleLocation = 'transparentTitleLocation',
  MediaRelLocation = 'mediaRelLocation',
  Thumbnail = 'thumbnail',
  ThumbnailLocation = 'thumbnailLocation',
  MediaPreviewUrl = 'mediaPreviewUrl',
  MediaPreviewLocation = 'mediaPreviewLocation',
  MediaPreviewDuration = 'mediaPreviewDuration',
  MediaDuration = 'mediaDuration',
  HasProcessed = 'hasProcessed',
  MinimumAppropriateAge = 'minimumAppropriateAge',
  ThumbnailDefaultUrl = 'thumbnailDefaultUrl',
}
export enum MediaMetaProperties {
  DescriptionId = 'Description-id',
  DescriptionVersion = 'Description-version',
  MediaInformationId = 'MediaInformation-id',
  MediaInformationVersion = 'MediaInformation-version',
  MediaReactionsId = 'MediaReactions-id',
  MediaReactionsVersion = 'MediaReactions-version',
  TagId = 'Tag-id',
  TagVersion = 'Tag-version',
  ThumbnailsId = 'Thumbnails-id',
  ThumbnailsVersion = 'Thumbnails-version',
}
